import { All, KeyValue } from "../interfaces";
import { connect } from "react-redux";
import * as actions from "../common/actions";
import { Dispatch } from "react";
import SummaryLevelTwo from "../components/SOD/SummaryTables/SummaryLevelTwo";

export function mapStateToProps({ appState }: All) {
  return {
    appState: (appState as KeyValue)[appState.app],
  };
}
function mapDispatchToProps(dispatch: Dispatch<actions.AllActions>) {
  return {
    updateSort: (sortField: string, sortDirection: string) => {
      dispatch(actions.updateSortOrder(sortField, sortDirection));
    },
    updatePagination: (pageNumber: number, resultLimit: number) => {
      dispatch(actions.updatePagination("pageNumber", pageNumber));
      dispatch(actions.updatePagination("resultLimit", resultLimit));
    },
    updateFilter: (filterField: string, value: string) => {
      dispatch(actions.updateFilter(filterField, value));
    },
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(SummaryLevelTwo);
